import React from 'react'

const CustomImageComponent = (props) => {
    const { src, alt, className, fetchPriority, loading = 'lazy', decoding, datanimg, style } = props;
    return (
        <img
            src={src}
            alt={alt}
            className={className}
            fetchPriority={fetchPriority}
            loading={loading}
            decoding={decoding}
            data-nimg={datanimg}

            style={style}
            onError={(e) => {
                e.target.onerror = null; // prevents infinite loop
                e.target.src = "/assets/img/imageNotFound.png"; // your dummy image path
            }}
        />
    )
}

export default CustomImageComponent